<template>
  <div id="c" v-clipboard="getEmail" class="d-flex flex-wrap flex-md-nowrap align-items-center mt-2 mb-2 contact-container" :style="{backgroundImage:createBackgroundString}">
    <a>
      <img class="contact-image" :src="require('../assets/' +image)">
    </a>
    <div class="text crypted" data-name="hugo.raguin" data-domain="gmail" data-tld="com"></div>
    <b-popover custom-class="popup-text" target="c" triggers="click" placement="top">Email copied in the clipboard !</b-popover>
  </div>
</template>

<script>
export default {
  name: "ContactMailSection",
  data(){
    return{
      pipi: false
    }
  },
  props:{
    image:{
      type: String,
      default: "/"
    },
    text:{
      type: String,
      default: "Text"
    },
    bColor0:{
      type: String,
      default: "rgb(28,156,234,0.3)"
    },
    bColor1:{
      type: String,
      default: "rgb(28,156,234,0.3)"
    },
    bColor2:{
      type: String,
      default: "rgb(28,156,234,0)"
    },
    progress:{
      type: Number,
      default: 100
    }
  },
  computed: {
    createBackgroundString() {
      return `linear-gradient(90deg,${this.bColor0} 0%, ${this.bColor0} 50%, ${this.bColor1} 50%, ${this.bColor2} ${this.progress}%)`;
    }
  },
  methods: {
    // eslint-disable-next-line
    clipboardSuccessHandler({value, event}) {
      console.log('success', value)
    },
    getEmail: function (){
      return "hugo" + "." + "raguin@" + "gm" + "ail.com"
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

  .contact-container{
    background-image: linear-gradient(#5187c4, #1c2f45);
    border-radius: 15px;
    background-size: 200% auto;
    background-position: right;
    transition: background-position 0.5s;
    cursor: pointer;
    justify-content: left;

    @media(max-width: 330px){
      justify-content: center;
    }
  }
  .contact-container:hover{
    background-position: left;
  }

  .contact-image{
    height: 45px;
    width: 45px;
    padding: 5px;

    @include media-breakpoint-up(sm) {
      height: 60px;
      width: 60px;
    }
  }

  .text{
    font-size: 1rem;
    margin-left: 10px;

    @include media-breakpoint-up(sm) {
      font-size: 1.3rem;
      margin-left: 10px;
    }

    @include media-breakpoint-up(md) {
      font-size: 1.5rem;
      margin-left: 20px;
    }
  }

  .crypted:after{
    content: attr(data-name) "@" attr(data-domain) "." attr(data-tld);
  }

  .popup-text{
    font-size: 1rem;
  }
</style>